import React from 'react'
import PropTypes from 'prop-types'

const BusIcon = ({ customClassName, width, height, fill, }) =>
  (<svg
    className={customClassName}
    width={width}
    height={height}
    aria-labelledby="Bus"
    viewBox="0 0 511.998 511.998"
  >
    <title id="bus-icon">Bus</title>
    <g>
      <path
        fill={fill}
        d="M503.467,153.6H25.6c-4.71,0-8.533,3.823-8.533,8.533v90.334L2.5,267.034c-1.604,1.604-2.5,3.772-2.5,6.033V332.8
  			c0,4.71,3.823,8.533,8.533,8.533h115.678c5.922,10.155,16.811,17.067,29.389,17.067c12.578,0,23.467-6.912,29.389-17.067H354.62
  			c5.922,10.155,16.811,17.067,29.389,17.067c12.826,0,23.885-7.194,29.713-17.673l91.273-16.597
  			c4.053-0.742,7.006-4.275,7.006-8.397v-153.6C512,157.423,508.177,153.6,503.467,153.6z M93.867,294.4
  			c0,2.355-1.911,4.267-4.267,4.267H55.467c-2.355,0-4.267-1.911-4.267-4.267v-93.867c0-2.355,1.911-4.267,4.267-4.267H89.6
  			c2.355,0,4.267,1.911,4.267,4.267V294.4z M153.6,341.333c-9.412,0-17.067-7.654-17.067-17.067S144.188,307.2,153.6,307.2
  			c9.412,0,17.067,7.654,17.067,17.067S163.012,341.333,153.6,341.333z M187.733,234.667c0,2.355-1.911,4.267-4.267,4.267H115.2
  			c-2.355,0-4.267-1.911-4.267-4.267v-34.133c0-2.355,1.911-4.267,4.267-4.267h68.267c2.355,0,4.267,1.911,4.267,4.267V234.667z
  			 M290.133,234.667c0,2.355-1.911,4.267-4.267,4.267h-76.8c-2.355,0-4.267-1.911-4.267-4.267v-34.133
  			c0-2.355,1.911-4.267,4.267-4.267h76.8c2.355,0,4.267,1.911,4.267,4.267V234.667z M311.467,238.933
  			c-2.355,0-4.267-1.911-4.267-4.267v-34.133c0-2.355,1.911-4.267,4.267-4.267h76.8c2.355,0,4.267,1.911,4.267,4.267v34.133
  			c0,2.355-1.911,4.267-4.267,4.267H311.467z M384,341.333c-9.412,0-17.067-7.654-17.067-17.067S374.588,307.2,384,307.2
  			c9.412,0,17.067,7.654,17.067,17.067S393.412,341.333,384,341.333z M494.933,234.667c0,2.355-1.911,4.267-4.267,4.267h-76.8
  			c-2.355,0-4.267-1.911-4.267-4.267v-34.133c0-2.355,1.911-4.267,4.267-4.267h76.8c2.355,0,4.267,1.911,4.267,4.267V234.667z"
      />h276.216c1.877,0,3.524-1.22,4.079-3.012l9.233-30.012C486.579,318.553,484.847,315.908,482.193,315.609z"
      />
    </g>
  </svg>)

BusIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  customClassName: PropTypes.string,
}

BusIcon.defaultProps = {
  width: 20,
  height: undefined,
  fill: 'blue',
  customClassName: '',
}

export default BusIcon



// WEBPACK FOOTER //
// ./src/components/icons/Bus.js